import countriesDictionaryEn from '../dictionaries/countries/en/countries.json';
import countriesDictionarySv from '../dictionaries/countries/sv/countries.json';
import positionsDictionaryEn from '../dictionaries/positions/en/positions.json';
import positionsDictionarySv from '../dictionaries/positions/sv/positions.json';

function translate(phrase, en, sv) {
  const translationId = en.find(
    (dictionaryEn) => dictionaryEn.name === phrase
  )?.id;
  const translation = sv.find(
    (dictionarySv) => dictionarySv.id === translationId
  )?.name;

  return translation || phrase;
}

export const translateCountry = (phrase) =>
  translate(phrase, countriesDictionaryEn, countriesDictionarySv);

export const translatePosition = (phrase) =>
  translate(phrase, positionsDictionaryEn, positionsDictionarySv);
